import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAdmin, formatErr } from "@/context/AdminAuth";
import { Logo } from "@/components/site/Header";

export default function AdminLogin() {
  const { user, login } = useAdmin();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { await login(email, password); nav("/admin"); } catch (ex) { setErr(formatErr(ex)); } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FAF7F2] px-4">
      <form data-testid="admin-login-form" onSubmit={submit} className="w-full max-w-sm rounded-3xl border border-[#E7E2DB] bg-white p-8 shadow-sm">
        <Logo />
        <h1 className="mt-6 flex items-center gap-2 font-serif-display text-3xl font-semibold"><Lock className="h-5 w-5 text-[#B85D43]" /> Admin login</h1>
        <p className="mt-1 text-sm text-[#78716C]">Private area for the Kurtaani team.</p>
        <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="mt-6 w-full rounded-xl border border-[#E7E2DB] bg-[#FAF7F2] px-4 py-3 text-sm outline-none focus:border-[#B85D43]" />
        <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="mt-3 w-full rounded-xl border border-[#E7E2DB] bg-[#FAF7F2] px-4 py-3 text-sm outline-none focus:border-[#B85D43]" />
        {err && <p data-testid="admin-login-error" className="mt-3 text-sm text-red-600">{err}</p>}
        <button data-testid="admin-login-button" disabled={busy} className="btn-primary mt-6 w-full">{busy ? "Signing in…" : "Sign in"}</button>
      </form>
    </div>
  );
}
